module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/File-cloud-459efde5a47d055bce6f523403883f3d.svg";